<div class="btn-group" role="group" [class.is-invalid]="ngControl.invalid">
  <button type="button" class="btn"
    [class.btn-success]="value === true"
    [class.btn-outline-secondary]="value !== true"
    [disabled]="isDisabled"
    (click)="setValue(true)">
    Yes
  </button>
  <button type="button" class="btn"
    [class.btn-success]="value === false"
    [class.btn-outline-secondary]="value !== false"
    [disabled]="isDisabled"
    (click)="setValue(false)">
    No
  </button>
</div>